module.exports = __webpack_public_path__ + "static/media/pzu.e29aa5c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pzu.svg
// module id = 616
// module chunks = 0